import React from "react";
import PropTypes from "prop-types";

const MultiColumnSection = ({section}) => {
  let { content, colour, bgColour, topMargin, bottomMargin, heading, column_types } = section;
  let blockColumns = 0;

  const renderFeaturedColumn = (column, columnType) => {
    let content = column.content;

    return (
      <div key={column.id} className={`col-1 col-md-1 col-lg-4-${columnType}`}>
        <div className="article hero article-hero" href={content.url}>
          <a href={content.url}>
            <img className={`w-100 ${columnType == '2' && 'ie-resize'}`} srcSet={content.image_srcset} alt={content.image_alt} src={content.image} />
          </a>

          <div className="article-copy copy">
            <a href={content.url} className="h1" dangerouslySetInnerHTML={{__html: content.heading}}></a>
            <div dangerouslySetInnerHTML={{__html: content.content}}></div>
          </div>

          {(content.display_date || (content.label && content.showLabel)) && (
            <div className="article-extra">
              <time>{content.display_date}</time>
              {content.label && content.showLabel && (
                <div className={`content-label label-${content.label_colour.toLowerCase()}`}>{content.label}</div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }

  const renderBlockColumn = (column) => {
    let hasSmallFeature = column_types.includes('2');
    let columnClass = hasSmallFeature ? 'col-md-2-1' : 'col-md-1 col-lg-4-1-flush';
    let columnArticleClass = hasSmallFeature ? '' : 'article article-list-md-2 article-list-lg-1';
    blockColumns += 1;

    return (
      <div key={column.id} className={`col-1 col-lg-4-1 col-num-${blockColumns} ${columnClass}`}>
        <ul className={`article-list ${columnArticleClass}`}>
          {column.items.map((item) => {
            let content = item.content;
            return (
              <li key={item.id}>
                {content.showImage && (
                  <a href={content.url}>
                    <img alt={content.image_alt} src={content.image} srcSet={content.image_srcset} className="ie-resize" />
                  </a>
                )}
                <div className="article-copy copy">
                  <a href={content.url} className="h2 ff-s" dangerouslySetInnerHTML={{__html: content.heading}}></a>
                  <div dangerouslySetInnerHTML={{__html: content.content}}></div>
                </div>
                {(content.display_date || (content.label && content.showLabel)) && (
                  <div className="article-extra">
                    <time>{content.display_date}</time>
                    {content.label && content.showLabel && (
                      <div className={`content-label label-${content.label_colour.toLowerCase()}`}>{content.label}</div>
                    )}
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }

  return (
    <div className={`wrapper block-wrapper bg-${bgColour} ${topMargin} ${bottomMargin}`}> 
      <div className="wrapper--inner flex flex-w-w flex-jc-sb multi-column">
        {heading && (
          <div className="section-heading">
            <h2 className={`ff-s h2 block-heading mt-0 color-${colour}`} dangerouslySetInnerHTML={{__html: heading}}></h2>
          </div>
        )}
        {content.columns.map((column, index) => {
          let columnType = column_types[index];
          if (columnType == 1) {
            return renderBlockColumn(column, index);
          } else {
            return renderFeaturedColumn(column, columnType);
          }
        })}
      </div>
    </div>
  );
}

MultiColumnSection.propTypes = {
  section: PropTypes.object.isRequired
}

export default MultiColumnSection;
